import React, { DetailedHTMLProps, HTMLAttributes } from "react";
import clsx from "clsx";
import * as classesX from "./ProductCard.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
  faExclamationCircle,
  faHeart as faHeartSolid,
} from "@fortawesome/pro-solid-svg-icons";
import { faHeart, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { ProductPrice } from "../ProductPrice";

const classes = classesX;
 
export const WishlistSelector = ({ 
    hit,
    isMedium,
    hasOneVariant,
    canWishlist,
    isGroupProduct,
    variants,
    Dialog,
    badgeText,
    title, 
    subtitle,
    currency,
    messageStyles,
    messageText,
    wishState,
    setWishState,
    handleWishClick,
    sanitiseTitle,
    cartState,
    setCartState
}) => {

    // const [wishState, setWishState] = React.useState({
    //     loading: null,
    //     open: false,
    //     ready: false,
    //     wishedVariants: {},
    // });

    // const handleWishClick = (variantId: number) => async () => {
    //     setWishState((prev) => ({
    //       ...prev,
    //       loading: variantId,
    //     }));
    //     const variant = variants.find(({ id }) => id === variantId);
    //     const data = {
    //       epi: variantId,
    //       empi: isGroupProduct ? variant.prod_id : hit.id,
    //       du: `${window.location.origin}/products/${isGroupProduct ? variant.handle : hit.handle}`,
    //       dt: isGroupProduct ? variant.title : hit.title,
    //       iu: isGroupProduct ? variant.image.src : hit.image.src,
    //       pr: Number(variant.price),
    //       vi: variant.title,
    //     };
    
    //     try {
    //       await new Promise<void>((resolve) =>
    //         window._swat.addToWishList(data, resolve)
    //       );
    
    //       setWishState((prev) => ({
    //         ...prev,
    //         wishedVariants: {
    //           ...prev.wishedVariants,
    //           [variantId]: true,
    //         },
    //       }));
    //     } catch (error) {
    //       console.error(error);
    //     }
    
    //     setWishState((prev) => ({
    //       ...prev,
    //       loading: null,
    //       open: false,
    //     }));
    // };

    // React.useEffect(() => {
    //     let mounted = true;
    
    //     const onInit = (products) => {
    //       const wishedVariants = products
    //         .filter(({ empi }) => empi === hit.id && !isGroupProduct || isGroupProduct && variants.filter(x => x.prod === empi))
    //         .reduce(
    //           (acc, { epi }) => ({
    //             ...acc,
    //             [epi]: true,
    //           }),
    //           {}
    //         );
    //       if (mounted) {
    //         setWishState((prev) => ({
    //           ...prev,
    //           ready: true,
    //           wishedVariants,
    //         }));
    //       }
    //     };
    
    //     if ("_swat" in window) {
    //       window._swat.fetch(onInit);
    //     } else {
    //       window.SwymCallbacks = window.SwymCallbacks || [];
    //       window.SwymCallbacks.push((swat) => {
    //         swat.fetch(onInit);
    //       });
    //     }
    
    //     return () => {
    //       mounted = false;
    //     };
    // }, []);

    return (
        <div
            className={'wishContainer ' + clsx(classes.wishContainer, {
                hidden: !wishState.ready || !canWishlist,
            })} 
            onMouseEnter={() => {
                isMedium &&
                !hasOneVariant &&
                setWishState((prev) => ({
                    ...prev,
                    open: true,
                }));
                isMedium &&
                !hasOneVariant &&
                setCartState((prev) => ({
                    ...prev,
                    open: false,
                }));
            }}
            onMouseLeave={() => {
                isMedium &&
                !hasOneVariant &&
                setWishState((prev) => ({
                    ...prev,
                    open: false,
                }));
            }}
        >
            <button
                type="button"
                aria-label={window.accessibilityStrings.addToWishlist}
                aria-haspopup="dialog"
                className={clsx("fab wishlistButton ", classes.wishButton, {
                    loading: isMedium && wishState.loading !== null,
                })}
                onClick={() => {
                    hasOneVariant && !isGroupProduct
                    ? handleWishClick(variants[0].id)()
                    : setWishState((prev) => ({
                        ...prev,
                        open: true,
                        }));
                }}
            >  
                <FontAwesomeIcon
                    icon={Object.keys(wishState.wishedVariants).length > 0 ? faHeartSolid : faHeart}
                    width={20}
                    height={20}
                />
            </button>
            <div
                className={clsx(classes.wishModal, {
                    [classes.open]: wishState.open,
                })}
            >
                <Dialog
                    lockScroll={!isMedium}
                    open={wishState.open}
                    onClose={() => {
                        setWishState((prev) => ({
                            ...prev,
                            open: false,
                        }));
                    }}
                    className={clsx(classes.wishDialog, {
                        [classes.open]: wishState.open,
                    })}
                >
                    <button
                        type="button"
                        className={clsx("fab", classes.dialogCloseButton)}
                        onClick={(event) => {
                            event.preventDefault();
                            setWishState((prev) => ({ ...prev, open: false }));
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} width={16} height={16} />
                    </button>
                    <div className={classes.dialogHeader}>
                        <div className={classes.dialogTitle}>
                            <div className="uppercase h4">
                                {window.variantStrings.addToWishlist}
                            </div>
                        </div>
                        <div className={classes.dialogItem}>
                            <div className={classes.dialogItemImage}>
                                <div className="media media--portrait">
                                    <img
                                    alt={hit.image?.alt}
                                    src={
                                        wishState.open
                                        ? window.Shopify.addSizeToImage(hit.image.src, 128)
                                        : null
                                    }
                                    srcSet={
                                        wishState.open
                                        ? `${window.Shopify.addSizeToImage(
                                            hit.image.src,
                                            128
                                            )} 1x, ${window.Shopify.addSizeToImage(
                                            hit.image.src,
                                            256
                                            )} 2x`
                                        : null
                                    }
                                    width={128}
                                    height={160}
                                    />
                                </div>
                            </div>
                            <div>
                            <div className={classes.dialogItemHeader}>
                                <p className={classes.quickBadge}>{badgeText}</p>
                                <p className={classes.dialogItemTitle}>{title}</p>
                                <p className={classes.dialogItemSubtitle}>{subtitle}</p>
                            </div>
                            <ProductPrice product={hit} currency={currency} />
                            <p className={classes.quickMessage} style={messageStyles}>
                                {messageText}
                            </p>
                            </div>
                        </div>
                    </div> 
                    <div role="group" className={classes.dialogList}>
                        {variants.map((variant) => (
                            <button
                                key={variant.id}
                                type="button"
                                onClick={handleWishClick(variant.id)}
                                className={clsx({
                                loading: wishState.loading === variant.id,
                                [classes.hitButton]: !isMedium,
                                [classes.dialogListItem]: isMedium,
                                [classes.groupProductDialogListItem]: isGroupProduct,
                                })}
                            >
                                {sanitiseTitle(variant.title)}
                            </button>
                            ))
                        }
                    </div>
                </Dialog>
            </div>
        </div>
    );
}